






















































import Vue from 'vue';
import Misc from '@/services/Misc';

import Validation from './Validation.vue';

export default Vue.extend({
	name: 'FormTextField',
	components: {
		Validation,
	},
	props: {
		label: {
			type: String,
			required: false,
		},
		type: {
			type: String,
			required: false,
			default: 'text',
		},
		placeholder: {
			type: String,
			required: false,
			default: '',
		},
		helper: {
			type: String,
			required: false,
		},
		helperClasses: {
			type: String,
			required: false,
			default: 'text-muted',
		},
		value: {
			required: true,
		},
		disabled: {
			type: String,
			required: false,
			default: '',
		},
		required: {
			type: Boolean,
			required: false,
			default: false,
		},
		maxlength: {
			type: Number,
			required: false,
		},
		validation: {
			type: Object,
			required: false,
			// tslint:disable-next-line
			default: function() {
				return {};
			},
		},
		autofocus: {
			type: Boolean,
			required: false,
			default: false,
		},
		showValidationMessage: {
			type: Boolean,
			required: false,
			default: true,
		},
		small: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			Misc,
			id: Misc.generageRandomString(),
		};
	},
	computed: {
		isValid() {
			if (this.validation.length > 0 && this.validation.$invalid) {
				return true;
			} else if (this.validation.length > 0 && !this.validation.$invalid) {
				return false;
			}

			return false;
		},
	},
	mounted() {
		if (this.autofocus) {
			this.$refs.textinput.focus();
		}

		this.$refs.textinput.addEventListener('keydown', async event => {
			if (event.ctrlKey === true && event.key === 'v') {
				await this.$nextTick(() => {
					this.$emit('update:value', event.target.value);
				});
			}
		});
	},
});
